import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.RettshjelpPrivat,
        tekst: 'Privatperson',
    },
    {
        id: KategoriSvarId.RettshjelpLandbruk,
        tekst: 'Landbruk',
    },
    {
        id: KategoriSvarId.RettshjelpNaring,
        tekst: 'Næring',
    },
];

export const Rettshjelp = () => {
    const { url } = useConfig().links.rettshjelplandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.RettshjelpPrivat) {
            navigate(urler().rettshjelpPrivatUrl);
        } else {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Rettshjelp));
        }
    };

    return (
        <GruppeLandingsside
            title="Rettshjelp"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            radioButtonsLabel="Skal du melde skaden for privatperson eller foretak?"
            radioButtonsSubLabel="Dersom du er en advokat som skal melde skade på vegne av din klient, må du ta stilling til hvilken rolle klienten har."
            kategoriId="rettshjelp"
        />
    );
};
